import React from "react";
import { MessageCircle, Star } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { MARKETPLACE, PLATFORM_LOGOS } from "@/data/treasures";

const GoogleG = () => (
  <svg viewBox="0 0 48 48" className="w-6 h-6" aria-hidden="true">
    <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z" />
    <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z" />
    <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z" />
    <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" />
  </svg>
);

const Fab = ({ href, label, testid, children, ring = "ring-gold/30", extraGlow = "" }) => (
  <a href={href} target="_blank" rel="noreferrer" data-testid={testid} aria-label={label}
    className={`group/fab relative flex items-center justify-center w-12 h-12 rounded-full bg-cream shadow-[0_6px_20px_rgba(0,0,0,0.25)] ring-1 ${ring} transition-all duration-300 hover:scale-110 ${extraGlow}`}>
    {children}
    <span className="pointer-events-none absolute right-full mr-3 whitespace-nowrap rounded-lg bg-espresso-deep text-cream text-xs px-3 py-1.5 opacity-0 translate-x-2 group-hover/fab:opacity-100 group-hover/fab:translate-x-0 transition-all duration-300 shadow-lg">
      {label}
    </span>
  </a>
);

export const FloatingActions = () => {
  const { t, contact } = useLang();
  const waMsg = "Grüezi Mara-Team, ich habe eine Frage.";
  return (
    <div className="fixed right-4 top-1/2 -translate-y-1/2 z-[8000] flex flex-col gap-3" data-testid="floating-actions">
      <Fab href={contact.googleReviews} label={t.reviews.google} testid="fab-google">
        <GoogleG />
        <span className="absolute -top-1 -right-1 w-5 h-5 rounded-full bg-gold flex items-center justify-center shadow">
          <Star className="w-3 h-3 fill-espresso-deep text-espresso-deep" />
        </span>
      </Fab>
      <Fab href={`https://wa.me/${contact.whatsapp}?text=${encodeURIComponent(waMsg)}`} label="WhatsApp" testid="fab-whatsapp"
        ring="ring-white/30" extraGlow="!bg-[#25D366] shadow-[0_6px_22px_rgba(37,211,102,0.55)] hover:shadow-[0_6px_30px_rgba(37,211,102,0.8)]">
        <MessageCircle className="w-6 h-6 text-white" />
      </Fab>
      <Fab href={MARKETPLACE.tutti} label={t.platforms.tutti} testid="fab-tutti">
        <img src={PLATFORM_LOGOS.tutti} alt="Tutti" className="w-8 h-8 object-contain" />
      </Fab>
      <Fab href={MARKETPLACE.ricardo} label={t.platforms.ricardo} testid="fab-ricardo">
        <img src={PLATFORM_LOGOS.ricardo} alt="Ricardo" className="w-8 h-8 object-contain" />
      </Fab>
    </div>
  );
};

export default FloatingActions;
